import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import tfgApi from '@/features/dashboard/tfg/api/tfgApi.ts';
import { tfgApiQueryKeys } from '@/features/dashboard/tfg/api/tfgApi.queryKeys.ts';
import { TfgSettingsWebDto } from '@/features/dashboard/tfg/types/TfgSettingsDto.ts';

export const getTfgSettingsQueryOptions = (
  tourId: string | undefined,
): UseQueryOptions<TfgSettingsWebDto> => ({
  queryKey: tfgApiQueryKeys.settings(tourId!),
  queryFn: () => tfgApi.getSettings(tourId!),
  enabled: !!tourId,
  staleTime: 1000 * 60,
});

const useGetTfgSettings = (tourId: string | undefined) => {
  return useQuery(getTfgSettingsQueryOptions(tourId));
};

export default useGetTfgSettings;
